// React / Next
import React from 'react';
import { ReactElement } from 'react';
import Link from 'next/link';
// UI components
import { Typography } from 'ui-components/';
// App
import Section from 'app-shared/lib/layout/shared/section';
import { ActionButton, ActionButtons } from 'app-shared/lib/components/buttons';
import { USER_ACCESS_PAGES_URLS } from '@/fragments/user-access/user-access.constants';

/**
 * Success callback displayed when activate account successed
 * @param props Step props
 */
const ActivateCallbackSuccess = (): ReactElement => {
  return (
    <Section id="callback-success">
      <Typography align="center">Votre compte a été activé avec succès.</Typography>
      <ActionButtons>
        <Link href={USER_ACCESS_PAGES_URLS['login']}>
          <ActionButton role="button" size="large" type="button">
            Se connecter
          </ActionButton>
        </Link>
      </ActionButtons>
    </Section>
  );
};

export default ActivateCallbackSuccess;
